import { Navigate } from 'react-router-dom';
import { ModuleGate } from '@/access/Gate';
import type { ModuleKey } from '@/access/modules';

/**
 * מסך ניהול של מודול כבוי חוזר לדשבורד.
 *
 * הטאב כבר מוסתר מהתפריט, אבל כתובת שמורה או קישור ישן עדיין
 * פתחו אותו — כלומר "כיבוי" שהסתיר ולא כיבה. כאן זה נסגר במבנה.
 *
 * לדשבורד ולא לדף הבית של העובד: מי שהגיע לכאן נמצא בקונסולה
 * והתכוון להישאר בה.
 */
export function AdminModuleRoute({
  module,
  children,
}: {
  module: ModuleKey;
  children: React.ReactNode;
}) {
  return (
    <ModuleGate module={module} fallback={<Navigate to="/admin" replace />}>
      {children}
    </ModuleGate>
  );
}
